// export const ROOT_URI = `https://find.mybiocalculus.com/assets/dist/user_records`;
export const ROOT_URI = `https://web5.mybiocalculus.com/assets/dist/user_records`;

// export const API_ENDPOINT = `https://data.mybiocalculus.com/api/api`;
export const API_ENDPOINT = "https://web5.mybiocalculus.com/api";

// export const API_ENDPOINT_V2 = "https://data.mybiocalculus.com/api/api";
export const API_ENDPOINT_V2 = "https://web5.mybiocalculus.com/api";

export const API_ENDPOINT_WEB = "https://web5.mybiocalculus.com/api";

export const API_ENDPOINT_DATA = "https://data.mybiocalculus.com/api/api";



/* ------------------------------------------------ */
/* FIRST PAGE PRIORITY (DO NOT DRAG THESE) */
/* ------------------------------------------------ */

export const FIRST_PAGE_IMAGE_PRIORITY = [
  { key: "sp", name: "Sinus Pause" },
  { key: "af", name: "Atrial Fibrillation" },
  { key: "vt", name: "Ventricular Tachycardia" },
  { key: "chb", name: "Complete heart block" },
  { key: "2avb", name: "2nd degree AV block" },
  { key: "flutter", name: "Atrial Flutter" },
  { key: "j", name: "Junctional beat" },
  { key: "pvc", name: "Premature Ventricular Ectopics" },
  { key: "pac", name: "Premature Atrial Ectopics" },
  { key: "pbt", name: "Pacemaker Beat" },
  { key: "st", name: "Sinus Tachycardia" },
  { key: "sb", name: "Sinus Bradycardia" },
  { key: "nsr", name: "Sinus Rhythm" },
  { key: "max", name: "Maximum HR" },
  { key: "min", name: "Minimum HR" },
];


/* ------------------------------------------------ */
/* ARRYTHMIA FOLDERS (THIS IS WHAT YOU DRAG) */
/* ------------------------------------------------ */

export const ARRYTHMIA_FOLDERS = [
  { key: "max", name: "Maximum HR" },
  { key: "min", name: "Minimum HR" },
  { key: "sym", name: "Triggered Event" },

  { key: "chb", name: "Complete heart block" },

  { key: "2avb_type1", name: "Type 1 2nd degree AV block" },
  { key: "2avb_type2", name: "Type 2 2nd degree AV block" },
  { key: "2avb2:1", name: "2:1 2nd degree AV block" },
  { key: "2avb3:1", name: "3:1 2nd degree AV block" },
  { key: "2avb", name: "2nd degree AV block" },

  { key: "bbb", name: "Bundle Branch Block" },
  { key: "1avb", name: "First degree AV block" },

  { key: "vt", name: "Ventricular Tachycardia" },

  { key: "pbt", name: "Paced Beats" },

  { key: "ays", name: "Asystole" },

  { key: "at", name: "3rd degree AV block" },

  { key: "sp", name: "Sinus Pause" },

  { key: "af", name: "Atrial Fibrillation" },

  { key: "flutter", name: "Atrial Flutter" },

  { key: "arrest", name: "Sinus Arrest" },

  { key: "block", name: "Sinus Block" },

  { key: "svt", name: "Supra Ventricular Tachycardia" },

  { key: "aivr", name: "Accelerated Idioventricular Rhythm (AIVR)" },

  { key: "ivr", name: "Idioventricular Rhythm (IVR)" },

  { key: "pjc", name: "Premature Junctional Complex" },

  { key: "run_pvc", name: "PVC Run" },
  { key: "triplet_pvc", name: "PVC Triplet" },
  { key: "couplet_pvc", name: "PVC Couplet" },
  { key: "bi_pvc", name: "PVC Bigeminy" },
  { key: "tri_pvc", name: "PVC Trigeminy" },
  { key: "pvc", name: "PVC" },

  { key: "run_pac", name: "PAC Run" },
  { key: "triplet_pac", name: "PAC Triplet" },
  { key: "couplet_pac", name: "PAC Couplet" },
  { key: "tri_pac", name: "PAC Trigeminy" },
  { key: "bi_pac", name: "PAC Bigeminy" },
  { key: "pac", name: "PAC" },

  { key: "sa", name: "Sinus Arrhythmia" },

  { key: "st", name: "Sinus Tachycardia" },

  { key: "sb", name: "Sinus Bradycardia" },

  { key: "j", name: "Junctional Beats" },

  { key: "ncar", name: "Non Conducted P Wave" },

  { key: "invt", name: "Inverted T Wave" },

  { key: "nsr", name: "Normal Sinus Rhythm" },
];


/* ------------------------------------------------ */
/* PRIORITY SORTING FUNCTION */
/* ------------------------------------------------ */

export function reorderByPriority(
  arr,
  storageKey = "report_priority_arrhythmia"
) {
  const saved = localStorage.getItem(storageKey);

  if (!saved) return arr;

  const priority = JSON.parse(saved);

  const order = priority.map((p) => p.key);

  return [...arr].sort((a, b) => {
    const indexA = order.indexOf(a.key);
    const indexB = order.indexOf(b.key);

    if (indexA === -1) return 999;
    if (indexB === -1) return -999;

    return indexA - indexB;
  });
}
export const PRIORITY_1_FIRST_PAGE = [
  "vt",
  "chb",
  "sp",
  "af",
  "j",
  "pvc",
  "pac",
];

export const PRIORITY_1_ARRHYTHMIA = [
  "max",
  "min",
  "ays",     // asystole
  "vt",
  "chb",
  "sp",
  "af",
  "pbt",     // paced
  "svt",
  "tri_pvc",
  "bi_pvc",
  "pvc",
  "tri_pac",
  "bi_pac",
  "pac",
  "j",
  "st",
  "sb",
  "nsr",
  "aivr",
  "ivr",
];

export function applyPriorityOrder(arr, priorityKeys) {
  return [...arr].sort((a, b) => {
    const indexA = priorityKeys.indexOf(a.key);
    const indexB = priorityKeys.indexOf(b.key);

    if (indexA === -1) return 999;
    if (indexB === -1) return -999;

    return indexA - indexB;
  });
}